const SnsLogin_ko = {
  ID_ACCOUNT_ALREADY_EXIST: "이미 계정이 있나요?",

  ID_SNS_BUTTON_METAMASK: "메타마스크 지갑으로 시작하기",
  ID_SNS_BUTTON_NAVER: "네이버로 시작하기",
  ID_SNS_BUTTON_KAKAO: "카카오로 시작하기",
  ID_SNS_BUTTON_FACEBOOK: "페이스북으로 시작하기",
  ID_SNS_BUTTON_GOOGLE: "구글로 시작하기",
  ID_SNS_BUTTON_OTHER: "다른 SNS로 시작하기",
  ID_SNS_BUTTON_MICROSOFT: "마이크로소프트로 시작하기",

  ID_LAST_LOGIN_TOOLTIP: "마지막으로 로그인한 SNS에요",

  ID_ACCOUNT_ALREADY_EXIST_NOTICE: "이미 가입된\n계정이 있어요",
  ID_AGAIN_LOGIN_BUTTOM: "다시 로그인하기",
  ID_EXIST_ACCOUNT_INFO_NOTICE_TITLE: "이전에 가입하신\n계정을 발견했어요",
  ID_ORIGINAL_ACCOUNT_CONNECT_BUTTON: "기존 레드브릭 계정과 연동하기",

  ID_CONNECT_ACCOUNT: "계정을 연동할까요?",
  ID_CONNECT_ACCOUNT_PASSWORD:
    "레드브릭 계정과 가입 중인 SNS 계정을 연동하시려면\n기존 레드브릭 계정의 비밀번호를 입력해주세요.",

  ID_SNS_COMPLETE_REGISTER_TITLE: "가입 완료",
  ID_SNS_COMPLETE_REGISTER_SUB_TITLE: "레드브릭에 오신 것을 환영해요!",
  ID_SNS_COMPLETE_REGISTER_INTRO: "레드브릭을 소개할게요",
  ID_SNS_ABOUT_REDBRICK_FIRST_TITLE: "놀랄만큼 쉬운 창작",
  ID_SNS_ABOUT_REDBRICK_FIRST_SUB_TITLE:
    "수천 개의 에셋들과 블록코딩으로\n내가 원하는 세상을 쉽게 만들어보세요.",

  ID_SNS_ABOUT_REDBRICK_SECOUND_TITLE: "내 콘텐츠가 수익으로",
  ID_SNS_ABOUT_REDBRICK_SECOUND_SUB_TITLE:
    "마켓에서 창작물을 판매하거나\n월드에 광고를 삽입해 수익을 내보세요",

  ID_LABEL_TO_BE_INTRODUCE: "도입 예정",

  ID_NEXT_STEP_BUTTON: "다음",

  ID_SNS_EMAIL: "이메일",
  ID_SNS_CREATED_AT: "가입일",

  ID_SNS_TOAST_MSG_LOGIN: "SNS ID로 로그인 되었습니다.",
  ID_SNS_TOAST_MSG_LOGOUT: "로그아웃 되었습니다.",
  ID_SNS_TOAST_MSG_SIGNUP: "SNS ID로 가입이 완료 되었어요.",
  ID_SNS_TOAST_MSG_CONNECT: "계정 연동이 완료되었습니다.",

  ID_SNS_CONNECT_COMPLETE_TITLE: "계정 연동을\n완료했어요",
  ID_SNS_CONNECT_COMPLETE_SUB:
    "이제 내 계정을 한번에 편리하게 관리할 수 있어요",
  ID_SNS_CONNECT_COMPLETE_POINT_1:
    "계정 연동이 완료되면 어떤 계정으로 로그인하든 같은 정보를 볼 수 있어요.",
  ID_SNS_CONNECT_COMPLETE_POINT_2:
    "연동된 계정은 삭제되지 않으며 기존과 동일하게 로그인할수 있어요",
  IS_SNS_CONNECT_COMPLETE_BUTTON: "메인으로",
  ID_SNS_REDBRICK_ACCOUNT: "레드브릭 계정",
  ID_SNS_ACCOUNT: "SNS 계정",
  ID_SNS_ALREADY_CONNECTED_ERR: "이미 해당 SNS로 연동된 계정이 있습니다.",
};

export default SnsLogin_ko;
